import { Modal, TextInput } from '@mantine/core';
import { ReactComponent as LeftArrowIcon } from 'assets/icons/orangeLeftArrow.svg';
import PrimaryButton from 'components/primaryButton';
import { Controller, useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';

import useAddNewSubFolder from '../../hooks/useAddnewsubFolder';

const AddNewSubFolderModal = ({
  addSubFolderModal,
  setAddSubFolderModal,
  name,
  historyOfPath,
}) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({ mode: 'onchange ' });

  const location = useLocation();

  const closeModal = () => {
    setAddSubFolderModal(false);
    reset({ name: '' });
  };

  const customTitle = () => {
    return (
      <div className='relative flex justify-center items-center text-xl mx-4 my-4'>
        <LeftArrowIcon
          onClick={closeModal}
          className='w-4 absolute left-0 cursor-pointer'
        />
        {/* <p>{folderId ? 'Update folder' : 'Create folder'}</p> */}
        <p>Create folder</p>
      </div>
    );
  };

  const getErrorMessage = (name) => {
    return (
      errors[name] && (
        <p className=' text-sm font-semibold text-red-500'>
          {errors[name]?.message}
        </p>
      )
    );
  };

  const addNewSubFolderMutation = useAddNewSubFolder(closeModal);

  const AddnewsubFolder = (data) => {
    addNewSubFolderMutation.mutate({
      path:
        name === 'Modal'
          ? `${historyOfPath}/${data?.name}`
          : `${location?.state?.path}/${data?.name}`,
    });
  };
  return (
    <Modal
      opened={addSubFolderModal}
      onClose={closeModal}
      title={customTitle()}
      withCloseButton={false}
      overlayColor={'#F8F7F799'}
      overlayBlur={20}
      overlayOpacity={0.5}
      centered
      size={600}
      radius='md'
      overflow='inside'
      transitionDuration={100}
      classNames={{
        title: 'w-full  font-semibold text-18',
        modal: 'pl-10',
        body: 'scroller -mr-4 pr-2',
      }}
    >
      <form className='px-4' onSubmit={handleSubmit(AddnewsubFolder)}>
        <div>
          <Controller
            control={control}
            name='name'
            rules={{
              required: 'Required',
              /* 
              This validation is commented as per the issue AG-537
              pattern: {
                value: /^[ A-Za-z0-9_@.#&+(-)]*$/,
                message: 'Input must be an alphabets or integers',
              }, */
            }}
            render={({ field }) => (
              <TextInput
                {...field}
                label='Name of the folder'
                size='md'
                classNames={{
                  input: 'border-primary',
                  label: 'text-neutralsGrey text-sm',
                }}
              />
            )}
          />
          {getErrorMessage('name')}
        </div>
        <div className='flex justify-center items-center my-5 mt-10'>
          <button>
            <PrimaryButton>Save</PrimaryButton>
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddNewSubFolderModal;
